export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'd640cc250fmsha7164ccf7abd470p13e752jsneccbc9eb7974',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo"

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "fa17ed82d1cc24646091acda8cf84bf1"
